import MetaDataValue from './MetaDataValue';

export default MetaDataValue;
